import { render, staticRenderFns } from "./caiji.vue?vue&type=template&id=3e878150&scoped=true"
import script from "./caiji.vue?vue&type=script&lang=ts"
export * from "./caiji.vue?vue&type=script&lang=ts"
import style0 from "./caiji.vue?vue&type=style&index=0&id=3e878150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e878150",
  null
  
)

export default component.exports